import { render, staticRenderFns } from "./questionnaire_field.vue?vue&type=template&id=648d65d0&scoped=true&"
import script from "./questionnaire_field.vue?vue&type=script&lang=js&"
export * from "./questionnaire_field.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire_field.vue?vue&type=style&index=0&id=648d65d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d65d0",
  null
  
)

export default component.exports